import React, { useEffect, useState, useMemo } from 'react';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/Stats.scss';
import { Segment } from 'tea-component';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { useDispatch, history, connect, getLocale } from 'umi';
import {
  getStatsPageLogMes,
  getCountroesPageLogMes,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import newzoowhite from '@/pages/intelligence/assets/svg/dataSource/action-theme.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import Vginsights from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import GamalyticIcon from '@/pages/intelligence/assets/svg/dataSource/gamalytic.svg';
import AlineaIcon from '@/pages/intelligence/assets/svg/dataSource/alinea.svg';
import SelectChoice from '@/pages/intelligence/components/SelectCompoenet/SelectChoice';
import IconDom from '@/pages/intelligence/components/SelectCompoenet/ItemDom/IconDom';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import SteamSales from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/SteamSales/Page';
import NewzooMetrics from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/NewzooMetrics';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { mergeRegionsCountriesList } from '@/pages/intelligence/utils/commonUtils';
import {
  newzooMetricsDetail,
  gamalyticSalesDetailList,
  steamSalesDetailList,
  alineaSalesDetailList,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { LANGUAGE_CN } from '@home/_config/config';
import DigitalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/DigitalRevenue';
import PhysicalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PhysicalRevenue';
import GSDData from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/GSDData';
import PCU from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PCU';
import GSDIcon from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import useGSDOptions from '@intelligence/pages/TopCharts/_hooks/useGSDOptions';
import useSummarySourceState from '@/pages/intelligence/components/SummaryCard/useSummarySourceState';
import SummaryCard from '@/pages/intelligence/components/SummaryCard';
import { getIfShowSourceExplanation } from '@/pages/intelligence/utils/topchartsUtils';
import SourceExplanation from '@/pages/intelligence/components/SummaryCard/components/SourceExplanation';

// Alinea 排在最前（默认勾选最高优先级），其次 Gamalytic，最后 VGI
// alineaSalesDetailList 与 gamalyticSalesDetailList 一一对齐（同名同数量），
// 两边 wishlists / wishlists_total 在下方 subOptionsList 过滤里统一去除
const newSteamSaleList = [
  ...alineaSalesDetailList,
  ...gamalyticSalesDetailList,
  ...steamSalesDetailList,
];

export default function PCStats(props: any) {
  const {
    gameId,
    tabType = 'stats',
    activeId,
    entityType,
    moduleName,
    activeSegment,
    setActiveSegment,
  } = props;

  const { formatMessage } = useIntlExtend();
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  const mainOptionList = [
    { text: formatMessage({ id: `dbi_pcu` }), value: 'pcu', svg: SteamIcon },
    {
      text: formatMessage({ id: `dbi_digital_revenue` }),
      value: 'digitalRevenue',
      svg: MscienceIcon,
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT5_HIGHLIGHT1,
    },
    {
      text: formatMessage({ id: `dbi_metric_gsd_sales_date` }),
      value: 'gsd',
      svg: GSDIcon,
    },
    {
      text: formatMessage({ id: `dbi_physical_revenue` }),
      value: 'physicalRevenue',
      svg: Npdicon,
    },
    {
      text: formatMessage({ id: `dbi_steam_sales` }),
      value: 'steamSales',
      svg: SteamIcon,
    },
    {
      text: formatMessage({ id: `dbi_newzoo_metrics` }),
      value: 'newzooMetrics',
      svg: NewzooIcon,
    },
  ];

  const subOptionsList = {
    newzooMetrics: { list: newzooMetricsDetail, svg: NewzooIcon },
    steamSales: {
      // Steam Sales 下拉：Alinea + Gamalytic + VGI（统一不展示 wishlists / wishlists_total）
      list: newSteamSaleList?.filter((item) => {
        const value = item?.value;
        return (
          value !== 'wishlists' &&
          value !== 'wishlists_total' &&
          value !== 'gamalytic__wishlists' &&
          value !== 'gamalytic__wishlists_total' &&
          value !== 'alinea__wishlists' &&
          value !== 'alinea__wishlists_total'
        );
      }),
      svg: Vginsights,
    },
  } as any;

  const subNewzooValues = newzooMetricsDetail?.map((item: any) => {
    return item.value;
  });
  const subSteamSalesValues = (subOptionsList?.steamSales?.list || [])?.map((item: any) => item.value);

  const mainOptionsValues = mainOptionList?.map((item) => {
    return item.value;
  });

  const getMainSegement = (activeSegment: string) => {
    if (subNewzooValues?.includes(activeSegment)) {
      return 'newzooMetrics';
    }
    if (subSteamSalesValues?.includes(activeSegment)) {
      return 'steamSales';
    }
    return mainOptionsValues?.includes(activeSegment)
      ? activeSegment
      : mainOptionsValues[0];
  };

  const [mainSegment, setMainSegment] = useState<string>(
    getMainSegement(activeSegment),
  );
  const [subSegment, setSubSegment] = useState<string>(activeSegment);
  // 增加纯国家列表以用来简称匹配全称用
  const [regionsCountries, setRegionsCountries] = useState<any>([]);

  // 获取全局国家地区数据（合并 common + rpd，与柱状图/接口 filter_type 对齐）
  const { regionOptions: commonRegionOptions } = useMarketFilterApi({});
  const { regionOptions: rpdRegionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.rpd,
  });

  useEffect(() => {
    setRegionsCountries(
      mergeRegionsCountriesList([commonRegionOptions, rpdRegionOptions]),
    );
  }, [commonRegionOptions, rpdRegionOptions]);

  const { openSource, handleClickSourceTips } = useSummarySourceState();

  const {
    // GSD options集合 接口loading
    loading: gsdOptionsLoading,
    // GSD segment的options集合
    segments: gsdSegments,
    // GSD device的options集合（级联）
    devices: gsdDevices,
    // GSD device的options集合（扁平化）
    devicesFlatten: gsdDevicesFlatten,
  } = useGSDOptions();

  // const [activeSegment, setUrlTab] = useState(activeSegment);
  const [loading, setLoading] = useState(true); // 用于给segment, loading时禁用， 也可以存在model中
  const [destroyed, setDestroyed] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    handlePageLog(mainSegment, gameId);
  }, []);

  const handlePageLog = (tab: string, gameId: string) => {
    const pageLogMes =
      tabType === 'countries'
        ? getCountroesPageLogMes(entityType, tab)
        : getStatsPageLogMes(entityType, tab);
    if (gameId && pageLogMes) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    recordPageMesForFeedback(pageLogMes);
  };

  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const changeUrl = (activeSubTab: string) => {
    history.replace(
      `/intelligence/topCharts/${
        moduleName || 'PCGames'
      }/gamesDetails/${gameId}/${activeId}/${activeSubTab}`,
    );
  };

  const optionsDom = mainOptionList.map((item) => {
    const svgTemp =
      mainSegment == 'newzooMetrics' && item?.value == 'newzooMetrics'
        ? newzoowhite
        : item?.svg;
    const itemTemp = {
      ...item,
      svg: svgTemp,
    };
    return {
      value: item.value,
      text: <IconDom data={itemTemp} />,
      className: item?.className,
    };
  });

  const renderSubSegment = (mainSegment: string) => {
    const subOption = subOptionsList[mainSegment];
    if (!Array.isArray(subOption?.list)) {
      return null;
    }
    const { svg } = subOption;
    const optionDom = subOption.list.map((item: any) => {
      const value = (item?.value || '').toString();
      let itemSvg = svg;
      if (value.startsWith('gamalytic__')) {
        const gamalyticMetricKey = value.replace(/^gamalytic__/, '');
        itemSvg = ['pcu', 'acu'].includes(gamalyticMetricKey)
          ? SteamIcon
          : GamalyticIcon;
      } else if (value.startsWith('alinea__')) {
        const alineaMetricKey = value.replace(/^alinea__/, '');
        itemSvg = ['pcu', 'acu'].includes(alineaMetricKey)
          ? SteamIcon
          : AlineaIcon;
      }
      return {
        value: item.value,
        text: (
          <IconDom
            data={{
              ...item,
              text: formatMessage({ id: item.text }),
              svg: itemSvg,
            }}
          />
        ),
      };
    });
    return (
      <SelectChoice
        className="dbi-stats-select-item"
        // className="segment-light retention-segment"
        labelValue={formatMessage({ id: 'dbi_label_metrics' })}
        changeValue={subSegment}
        optionsList={optionDom}
        getSelectMultiple={(value: any) => {
          // console.log('valuevalue', value);
          // setchange1(value);
          // if (value == 'est_units' || value == 'est_revenue') {
          // }
          setSubSegment(value);
          setActiveSegment(value);
          changeUrl(value);
        }}
        listWidth={isCN ? 270 : 310}
      />
    );
  };

  const PCUPhysicalDigitalComp =
    mainSegment == 'physicalRevenue'
      ? PhysicalRevenue
      : mainSegment == 'digitalRevenue'
      ? DigitalRevenue
      : mainSegment == 'gsd'
      ? GSDData
      : PCU;

  return (
    <div className="dbi-mobile-games-stats">
      <div className="mobile-games-flex">
        <Segment
          className="segment-light games-left"
          value={mainSegment}
          onChange={(value) => {
            let activeSegmentForUrl = value;
            // TODO 有子标签的需要设置默认值
            if (value === 'newzooMetrics') {
              setSubSegment(subNewzooValues[0]);
              activeSegmentForUrl = subNewzooValues[0];
            } else if (value === 'steamSales') {
              setSubSegment(subSteamSalesValues[0]);
              activeSegmentForUrl = subSteamSalesValues[0];
            }
            setActiveSegment(activeSegmentForUrl);
            setMainSegment(value);
            handlePageLog(value, gameId);
            setDestroyed(true);
            setTimeout(() => {
              setDestroyed(false);
            }, 0);
            changeUrl(activeSegmentForUrl);
          }}
          options={optionsDom}
        />
        {getIfShowSourceExplanation(mainSegment) && (
          <div className="dbi_pcconsole_source_explanation-div">
            <SourceExplanation
              textValue={'dbi_pcconsole_source_explanation'}
              handleClickSourceState={handleClickSourceTips}
              openSource={openSource}
              isNeedLeft={false}
            />
          </div>
        )}
      </div>

      {openSource && getIfShowSourceExplanation(mainSegment) && (
        <SummaryCard isSourceTips={true} openSource={openSource} />
      )}

      {destroyed ? null : mainSegment == 'steamSales' ? (
        <SteamSales
          {...props}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          entityType={entityType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
          newSteamSaleList={newSteamSaleList}
        />
      ) : mainSegment == 'newzooMetrics' ? (
        <NewzooMetrics
          {...props}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          entityType={entityType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
        />
      ) : (
        // pcu , physicalRevenue ,digitalRevenue
        <PCUPhysicalDigitalComp
          {...props}
          pageId={mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          entityType={entityType}
          regionsCountries={regionsCountries}
          mainSegment={mainSegment}
          subSegment={subSegment}
          gsdOptionsLoading={gsdOptionsLoading}
          gsdDeviceOptions={gsdDevicesFlatten}
          gsdSegmentOptions={gsdSegments}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
        />
      )}
    </div>
  );
}

connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(PCStats);
